import React from 'react'
import required from '../../../../common/validators/required'
import _ from 'lodash'
import { getPrametersByType, defaultParams } from '../../../../common/step'

import {
  Input,
  TranslatedInput,
  TranslatedTextArea,
  ImageUpload,
  IngredientsSelector,
  StepSelect,
} from  '../../../../components'

import S from './styled'

const NumberInput = ({ name, title, number, model, readOnly }) => (
  <Input {...{
    name, number,
    title,
    validate: required,
    min: 0,
    inverted: true,
    disabled: readOnly,
  }}
  />
)


const StepDetails = ({
  step,
  steps,
  stepsModel,
  ingredients,
  recipeIngredient,
  currentIngredients,
  defaultLocale,
  stepPrefix,
  stepPrefixWithParent,
  handleTranslationChange,
  locales,
  stepPath,
  parentStep,
  locked,
  applianceTypes,
  appliance,
  applianceType,
  isCustomType,
}) => {

  const { model, text, number, image, onChange } = stepsModel

  // const IngredientValidator = useMemo(
  //   () => () => recipeIngredient.ingredient ? undefined : 'Field is required',
  //   [recipeIngredient.ingredient],
  // )

  const fieldsRequired = ['cooking', 'preparation'].includes(step.type)

  const parametersByType = ['cooking', 'preparation'].includes(step.type) ? getPrametersByType(applianceType) : defaultParams

  return (
    <React.Fragment>
      <S.StepDetailsRow>
        <TranslatedInput {...{
          name: stepPrefix(`title.${defaultLocale}`),
          text,
          title: 'Title',
          locales,
          defaultLocale,
          translatedField: stepPrefix`title`,
          translates: _.get(model, stepPrefix`title`, {}),
          onTranslationChange: handleTranslationChange,
          inverted: true,
          validate: required,
          disabled: locked,
        }}/>
        {
          ['final', 'cooking'].includes(step.type) ? (
            <TranslatedInput {...{
              name: stepPrefix(`name.${defaultLocale}`),
              text,
              title: 'Name',
              locales,
              defaultLocale,
              translatedField: stepPrefix`name`,
              translates: _.get(model, stepPrefix`name`, {}),
              onTranslationChange: handleTranslationChange,
              inverted: true,
              validate: required,
              disabled: locked,
            }}/>
          ) : (
            <IngredientsSelector {...{
              path: stepPrefix(''),
              ingredient: recipeIngredient.ingredient,
              text,
              onChange,
              title: 'Ingredient',
              inverted: true,
              //  validate: fieldsRequired ? IngredientValidator : null,
              ingredients,
              section: recipeIngredient.section,
              defaultLocale,
              currentIngredients,
              readOnly: !!parentStep,
              step,
              disabled: locked,
            }}/>
          )
        }
      </S.StepDetailsRow>
      {
        !(isCustomType && step.type === 'cooking') && (
          <S.StepDetailsRow>
            <S.ImageContainer>
              <ImageUpload
                {...image({
                  name: stepPrefix`backgroundImage`,
                  title: 'Background Image',
                  validate: fieldsRequired && step.type !== 'preparation' ? required : null,
                  optional: step.type !== 'cooking',
                })}
                height="370"
                mobileWidth="185" mobileHeight="185"
                noStretch
                noBorder
                readOnly={locked}
              />
            </S.ImageContainer>
            <S.ImageContainer>
              <ImageUpload
                {...image({
                  name: stepPrefix`video`,
                  title: 'Top Image/Video',
                  validate: fieldsRequired && !(isCustomType && step.type === 'cooking') ? required : null,
                  optional: !fieldsRequired,
                })}
                height="370"
                mobileWidth="185" mobileHeight="185"
                allowVideo
                noBorder
                noStretch
                readOnly={locked}
              />
            </S.ImageContainer>
          </S.StepDetailsRow>
        )
      }

      <S.StepDetailsRow>
        <TranslatedTextArea {...{
          name: stepPrefix(`description.${defaultLocale}`),
          text,
          title: 'Description Text',
          rows: 10,
          validate: fieldsRequired ? required : null,
          locales,
          defaultLocale,
          translatedField: stepPrefix`description`,
          translates: _.get(model, stepPrefix`description`, {}),
          onTranslationChange: handleTranslationChange,
          withLibrary: true,
          inverted: true,
          optional: !fieldsRequired,
          disabled: locked,
        }}
        />
      </S.StepDetailsRow>
      <S.StepValuesRow>
        <StepSelect {
        ...{
          name: stepPath,
          step: parentStep ? parentStep : step,
          steps,
          inverted: true,
          onChange,
          jumpIndex: 1,
          defaultLocale,
          disabled: !!parentStep || locked,
        }
        }
        />
        <StepSelect {
        ...{
          name: stepPath,
          step: parentStep ? parentStep : step,
          steps,
          inverted: true,
          onChange,
          jumpIndex: 2,
          defaultLocale,
          disabled: !!parentStep || locked,
        }
        }
        />
        {
          !isCustomType && (
            <React.Fragment>
              <NumberInput
                model={model} name={stepPrefixWithParent`stepJumpStart`} number={number}
                title="Step Jump Start"
                readOnly={!!parentStep || locked}
              />
              <NumberInput
                model={model} name={stepPrefixWithParent`stepJumpLength`} number={number}
                title="Step Jump Length"
                readOnly={!!parentStep || locked}
              />
            </React.Fragment>
          )
        }
      </S.StepValuesRow>
      {
        parametersByType.map((pRow, rowIndex) => (
          <S.StepValuesRow key={`${applianceType}_${rowIndex}`}>
            {
              pRow.map(param => (
                <NumberInput
                  key={`${param.field}`}
                  model={model} name={stepPrefixWithParent(`${param.field}`)} number={number}
                  title={param.title}
                  readOnly={!!parentStep || locked}
                />
              ))
            }
          </S.StepValuesRow>
        ),
        )
      }
    </React.Fragment>
  )
}

export default StepDetails
